import {
  Box,
  Table as MUITable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { FC } from "react";
import { TableProps } from "./table.types";

const Table: FC<TableProps> = ({
  headCells,
  bodyCells,
  count,
  page,
  rowsPerPage,
  rowsPerPageOptions,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const showPagination =
    count !== undefined ||
    page !== undefined ||
    rowsPerPage !== undefined ||
    onPageChange;
  return (
    <Box sx={{ width: "100%" }}>
      <TableContainer>
        <MUITable size={"medium"}>
          <TableHead>
            <TableRow>
              {headCells.map((headCell, index) => (
                <TableCell key={index}>{headCell}</TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {bodyCells.map((row, index) => (
              <TableRow
                hover
                role="checkbox"
                tabIndex={-1}
                key={index}
                sx={{ cursor: "pointer" }}
              >
                {row.map((cell, index) => (
                  <TableCell key={index} align="left">
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </MUITable>
      </TableContainer>
      {showPagination && (
        <TablePagination
          component="div"
          page={page ?? 0}
          count={count ?? 0}
          rowsPerPage={rowsPerPage ?? 5}
          rowsPerPageOptions={rowsPerPageOptions ?? []}
          onPageChange={(_, newPage) => onPageChange?.(newPage)}
          onRowsPerPageChange={
            onRowsPerPageChange
              ? (event) => onRowsPerPageChange(Number(event.target.value))
              : undefined
          }
        />
      )}
    </Box>
  );
};

export { Table };
